import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoByn: CultureInfo = {
  name: 'byn',
  displayName: 'ብሊን',
  iso3LanguageCode: 'byn',
  iso2LanguageCode: 'byn',
  ietfLanguageTag: 'byn',
  parent: null
};
